import { Box, IconButton, InputBase } from "@mui/material";
import type { InputBaseProps } from "@mui/material";

import { Search, X } from "lucide-react";

export interface SearchFieldProps extends Omit<InputBaseProps, "startAdornment" | "endAdornment"> {
    onClear?: () => void;
}

/**
 * Input de búsqueda tipo píldora (`.tb-search` en el mockup de Claude Design
 * `BPM - Lendia (solicitudes).html`): borde/foco en tonos navy del tema
 * `bpmV2Theme`, ícono de lupa fijo a la izquierda y botón de limpiar opcional
 * a la derecha, solo visible cuando hay texto.
 */
export const SearchField = ({ onClear, value, sx, ...rest }: SearchFieldProps) => (
    <Box sx={{ position: "relative", display: "flex", alignItems: "center", ...sx }}>
        <Box
            sx={{
                position: "absolute",
                left: 14,
                display: "flex",
                alignItems: "center",
                color: "text.secondary",
                pointerEvents: "none",
            }}
        >
            <Search size={16} />
        </Box>
        <InputBase
            {...rest}
            value={value}
            fullWidth
            sx={{
                height: 38,
                pl: 5,
                pr: value ? 5 : 1.75,
                borderRadius: 999,
                border: "1px solid",
                borderColor: "divider",
                backgroundColor: "background.paper",
                fontSize: "0.8125rem",
                transition: "border-color 0.15s ease, box-shadow 0.15s ease",
                "&.Mui-focused": {
                    borderColor: "secondary.main",
                    boxShadow: (theme) => `0 0 0 3px ${theme.palette.info.light}`,
                },
            }}
        />
        {Boolean(value) && onClear && (
            <IconButton
                size="small"
                onClick={onClear}
                sx={{ position: "absolute", right: 6, color: "text.secondary" }}
            >
                <X size={14} />
            </IconButton>
        )}
    </Box>
);
